import { AccountInterface, AccountMetaInterface } from '@interface/account/account.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialAccountsState: BaseStoreInterface<Record<string, AccountInterface>, AccountMetaInterface> = {
  ...BaseStoreStructure,
  data: {},
  meta: {
    currentId: '',
    usageQuantity: '',
  },
};
